import * as React from 'react';

import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import { Button, Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { PageLayout } from '@kamernet/core/PageLayout';
import { NavLink } from '@kamernet/core/Routing/NavLink';
import { ROUTES } from '@kamernet/core/Routing/routes';

import styles from './ListingNotFound.module.css';

export const ListingNotFound = () => {
  const { T, locale } = useIntl();

  return (
    <PageLayout.MainContainer>
      <section className={styles.root}>
        <Typography variant="h1">
          {T('LBL_UNAVAILABLE_ADVERT_SUBTITLE')}
        </Typography>
        <div>
          <Typography variant="body1">
            {T('LBL_UNAVAILABLE_ADVERT_TEXT')}
          </Typography>
        </div>
        <div>
          <NavLink.Anchor
            variant="body3Bold"
            href={ROUTES.ListingsSearchCity.getURL({}, locale)}
          >
            <Button
              variant="contained"
              startIcon={<ArrowBackIosNewOutlinedIcon />}
            >
              {T('LBL_UNAVAILABLE_ADVERT_BTN_TEXT')}
            </Button>
          </NavLink.Anchor>
        </div>
      </section>
    </PageLayout.MainContainer>
  );
};
